import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import {
  initStorage,
  isStorageAvailable,
  getStorageData,
  isStorageLoading
} from '../../../../redux/actions/common/storage/init'

import Manager from './manager'

const Browse = (props) => {
  const dispatch = useDispatch()

  useEffect(() => {
      const ret = dispatch(initStorage())

      ret.then((response) => {
          //const newList = breadcrumbList.concat(response.data);
          //setBreadcrumbList(newList);
      }).catch((e) => {})
  }, [])

  const loading = useSelector(isStorageLoading)
  const data = useSelector(getStorageData)

  const storageAvailable = useSelector(isStorageAvailable)

  if (storageAvailable) {
    return <Manager storage={data?.storage} defaults={data?.defaults} />
  }

  return null
}

export default Browse
